var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      "fill-rule": "evenodd",
      d:
        "M58.537.838C50.253.588 17.074.745 8.621 11.105-3.18 25.57-2.887 54.021 19.235 60.621c20.322 6.063 46.524 8.777 56.276 9.072 6.367.193 39.326-1.9 51.689-12.402 8.683-7.377 8.545-20.539-.376-35.876C118.017 4.538 64.144 1.008 58.537.838z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ece878a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ece878a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_SVG/ShapeYearBtn3Mob.vue
// module id = JVRg
// module chunks = 1